import { Expression } from "./ExpressionBuilderTypes";

export class ExpressionJson {

    /**
     * Parses the query builder JSON.
     * Returns null for an empty or malformed value instead of throwing:
     * steps imported from Twilio have no builder JSON at all.
     */
    public static Parse(json: string): Expression | null {
        if (json === undefined || json === null || json.trim() === '') {
            return null
        }
        try {
            let parsed = JSON.parse(json)
            if (parsed === null || typeof parsed !== 'object' || !Array.isArray(parsed.rules)) {
                return null
            }
            return parsed as Expression
        }
        catch {
            return null
        }
    }
}
